var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('qd-message',{attrs:{"title":_vm.sprintTitle,"closable":_vm.title == _vm.sprintTitle,"type":"is-default","aria-close-label":"Close message"}},[_c('div',{staticClass:"height-max-57vh",domProps:{"innerHTML":_vm._s(_vm.sprint)}})])}
var staticRenderFns = []

export { render, staticRenderFns }